import { OptionInterface } from '@codebuild/cookie-jar/libs/form/interfaces/option.interface';
import { Select } from '@codebuild/cookie-jar/uikit/components/input/select';
import * as React from 'react';

export class SingleLineSelect extends Select {
    public howToRenderValue(input: OptionInterface) {
        return <span className={'Ellipsis clear-classes'}>{input?.title || '-'}</span>;
    }
}
